// Pre-registration funnel tracking. Creates an Applicant on first signup-page
// view and stamps each step. The server returns a SIGNED id; we store that and
// send it back on every update (the raw id is never exposed). See
// app/controllers/applicants_controller.rb.

const UTM_TTL_DAYS = 30
const STORAGE_KEY = "wc_applicant_id"
const UTM_KEY = "wc_applicant_utms"

function getStoredUtms() {
  try {
    const raw = localStorage.getItem(UTM_KEY)
    if (!raw) return {}
    const { utms, expires } = JSON.parse(raw)
    if (Date.now() > expires) { localStorage.removeItem(UTM_KEY); return {} }
    return utms
  } catch { return {} }
}

function captureUtms() {
  const p = new URLSearchParams(window.location.search)
  const utm_source = p.get("utm_source")
  const utm_campaign = p.get("utm_campaign")
  if (!utm_source && !utm_campaign) return getStoredUtms()

  const utms = { utm_source: utm_source || null, utm_campaign: utm_campaign || null }
  const expires = Date.now() + UTM_TTL_DAYS * 86400 * 1000
  try { localStorage.setItem(UTM_KEY, JSON.stringify({ utms, expires })) } catch {}
  return utms
}

async function initApplicant() {
  const existing = localStorage.getItem(STORAGE_KEY)
  if (existing) return existing

  try {
    const res = await fetch("/applicants", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(captureUtms())
    })
    if (!res.ok) return null
    const { id } = await res.json()
    localStorage.setItem(STORAGE_KEY, id)
    return id
  } catch { return null }
}

function trackStep(step, extra = {}) {
  const id = localStorage.getItem(STORAGE_KEY)
  if (!id) return
  fetch(`/applicants/${encodeURIComponent(id)}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ step, ...extra })
  }).catch(() => {})
}

export { captureUtms, initApplicant, trackStep }
